import styled from 'styled-components/macro';

import Button from 'components/Button/Button';
import FlexContainer from 'components/FlexContainer/FlexContainer';
import { FormInput } from 'components/Form';
import { ErrorMessageStyled } from 'components/Form/ErrorMessage/ErrorMessage.styled';
import { LabelStyled } from 'components/Input/Input.styled';
import Typography from 'components/Typography/Typography';

export const getPopupContentStyle = (isMobile: boolean) => ({
  width: '100%',
  height: isMobile ? '100%' : 'auto',
  maxWidth: isMobile ? 'none' : '430px',
  padding: isMobile ? '1.25rem 1.25rem 1.375rem' : '1.5rem 1.875rem 1.375rem',
});

export const TypographyTitleStyled = styled(Typography)`
  margin-bottom: 1.875rem;
`;

export const FormStyled = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 0.625rem;
`;

export const FormElementWrapStyled = styled.div`
  margin-bottom: 1rem;
`;

export const AttachmentWrapStyled = styled(FlexContainer)`
  ${LabelStyled} {
    margin-bottom: 0;
  }

  ${ErrorMessageStyled} {
    display: none;
  }
`;

export const AttachmentPhotoWrapStyled = styled.div`
  margin-left: 1rem;
`;

export const AttachmentNameStyled = styled(Typography)`
  align-self: center;
  margin-left: 0.625rem;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const AttachmentErrorStyled = styled(Typography)`
  margin-top: 0.375rem;
`;

export const IconWrapStyled = styled(FlexContainer)`
  cursor: pointer;
  width: 50px;
  height: 50px;
  border: ${({ theme }) => `${theme.borders.xs} ${theme.colors.primary.variant6}`};
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => theme.radius.md};
  transition: 0.3s;

  @media (hover: hover) {
    &:hover {
      border-color: ${({ theme }) => theme.colors.secondary.variant5};

      svg path {
        fill: ${({ theme }) => theme.colors.secondary.variant5};
      }
    }
  }

  ${({ theme }) => `
    ${theme.devices.tablet} {
      width: 38px;
      height: 38px;
    }
  `}
`;

export const AttachmentFormInputStyled = styled(FormInput)`
  display: none;
`;

export const ActionBtnStyled = styled(Button)`
  height: 48px;
  flex: 1 1;
  font-size: ${({ theme }) => theme.fontSize['2xl']};

  &:first-child {
    margin-right: 1rem;
  }

  ${({ theme }) => `
    ${theme.devices.tablet} {
      height: 38px;
      font-size: ${theme.fontSize.lg};
    }
  `}
`;

export const FlexContainerMessageStyled = styled(FlexContainer)`
  ${({ theme }) => `
    ${theme.devices.tablet} {
      padding: 0 2.5rem 0.625rem;
    }
  `}
`;

export const FlexContainerControlsStyled = styled(FlexContainer)`
  margin-top: 1rem;
`;
